import { useQuery } from '@tanstack/react-query';
import { getCostAttributionConfig } from "@/helpers/costAttributionApi";
import type { CostAttributionResponse } from "@/helpers/costAttributionApi";

interface UseCostAttributionReturn {
  costAttribution: CostAttributionResponse;
  isLoading: boolean;
  refetch: () => void;
}

const DEFAULT_CONFIG: CostAttributionResponse = {
  enabled: false,
  mode: "warehouse"
};

export const useCostAttribution = (): UseCostAttributionReturn => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["costAttributionConfig"],
    queryFn: getCostAttributionConfig,
  });

  return {
    costAttribution: data || DEFAULT_CONFIG,
    isLoading,
    refetch
  };
};